var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-card',{staticClass:"legend-card",attrs:{"header":_vm.groupName,"header-text-variant":"primary","header-tag":"header","header-bg-variant":"light"}},[(_vm.layerGroup.description)?_c('small',{domProps:{"textContent":_vm._s(_vm.layerGroup.description)}}):_vm._e(),(_vm.legend.display === 'Horizontal')?_c('div',{staticClass:"d-flex"},[_c('div',{staticClass:"d-flex flex-column"},[_c('div',{staticClass:"d-flex justify-content-between"},[_c('span',{staticStyle:{"margin-right":"10px"},domProps:{"textContent":_vm._s(_vm.legend.min)}}),_c('span',{staticStyle:{"margin-left":"5px"},domProps:{"textContent":_vm._s(_vm.legend.max)}})]),_c('div',{staticClass:"reverse"},_vm._l((_vm.legend.legendItems),function(item,key){return _c('svg',{key:key + item.color,style:({
            backgroundColor: [0, 3].includes(_vm.legend.type)
              ? item.color
              : 'transparent',
            borderRadius: _vm.legend.type === 3 ? '50%' : 0,
            border: '2px solid',
            borderColor: [0, 3].includes(_vm.legend.type)
              ? 'transparent'
              : item.color,
            width: '1rem',
            marginRight: '2px',
          }),attrs:{"viewBox":"0 0 1 1"}})}),0)])]):_c('div',_vm._l((_vm.legend.legendItems),function(item){return _c('div',{key:item.color},[(item.color)?_c('svg',{style:({
          backgroundColor: [0, 3].includes(_vm.legend.type)
            ? item.color
            : 'transparent',
          borderRadius: _vm.legend.type === 3 ? '50%' : 0,
          border: '2px solid',
          borderColor: [0, 3].includes(_vm.legend.type)
            ? 'transparent'
            : item.color,
          width: '1rem',
          marginRight: '.5rem',
        }),attrs:{"viewBox":"0 0 1 1"}}):_vm._e(),(item.icon)?_c('img',{style:({
          marginRight: '.5rem',
          clip: _vm.legend.type === 4 ? 'rect(2px, 60px, 23px, 2px)' : 'auto',
          maxHeight: _vm.legend.type === 4 ? 'initial' : '1.2rem',
          position: _vm.legend.type === 4 ? 'absolute' : 'initial',
        }),attrs:{"src":require(`../../${item.icon}`)}}):_vm._e(),_c('span',{staticStyle:{"margin-right":"10px"},domProps:{"textContent":_vm._s(item.description)}}),_c('br')])}),0),_c('footer',[_c('small',[_vm._v("Source: "),_c('cite',{attrs:{"title":"Source Title"},domProps:{"textContent":_vm._s(_vm.layerGroup.source)}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }